import React, { useEffect, useState } from 'react';
import InnerDashboard from './InnerDashboard';
import { useAuthentication } from '../../../../hooks/useAuthentication';
import { getInvoicesList } from '../../../../services/apis';

const InnerDashboardContainer = ({ ...props }) => {
  const { userInfo } = useAuthentication();

  const [statistics, setStatistics] = useState({
    thisYear: 0,
    limit: 0,
    invoicesAllTime: 0,
    notesAllTime: 0,
    total: 0,
  });

  const callGetInvoicesList = (tax_number) => {
    getInvoicesList(tax_number)
      .then((resp) => {
        const invoices = resp?.data || [];
        const generatedThisYear = Array.isArray(invoices) ? invoices.length : 0;
        const generatedInvoices = resp?.data?.generatedInvoices || 0;
        const generatedNotes = resp?.data?.generatedNotes || 0;
        setStatistics({
          thisYear: generatedThisYear,
          limit: 500,
          invoicesAllTime: +generatedInvoices,
          notesAllTime: +generatedNotes,
          total: +generatedInvoices + +generatedNotes,
        });
      })
      .catch((err) => {
        console.log({ err });
      });
  };

  useEffect(() => {
    if (userInfo) {
      callGetInvoicesList(userInfo.tax_number);
    }
  }, [userInfo]);

  return <InnerDashboard {...props} statistics={statistics} />;
};

export default React.memo(InnerDashboardContainer);
